import React, { useEffect } from 'react'
import { Table, Button } from 'antd'
import { ColumnsType } from 'antd/es/table'
import useGlobalModel from '@/model/globalModel'
import { useDangerModel } from '../dangerModel'
import { IDangerDetail } from '../dangerService'
import useNavModel from '@/model/navModel'
import { ApartmentOutlined, SafetyOutlined, EditOutlined } from '@ant-design/icons'
import { assignStatus } from '@/types/AppEnums'
import { changeTime } from '@/utils/utils'
import YhTootip from '@/components/YhTootip'
import { AssignTechnicians } from './assignTechnicians'
import { CheckAcceptance } from './checkAcceptance'
import { EditDangerModal } from './editDangerModal'

export function DataTable() {
    const {
        user: { userType },
    } = useGlobalModel(({ user }) => [user])

    const {
        dataSource,
        selectedRowKeys,
        pgCfg,
        loading,
        isModalVisible,
        acceptModalVisible,
        editModalVisible,
        setAcceptModalVisible,
        setMaintenanceId,
        setIsModalVisible,
        setEditModalVisible,
        setEditFormData,
        loadData,
        setSelectedRowKeys,
        setAcceptRecord,
    } = useDangerModel()

    useEffect(() => {
        loadData().then(() => {})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const { addNav, findNav, switchNavState } = useNavModel(() => [])
    const showModal = (val: any) => {
        setMaintenanceId(val)
        setIsModalVisible(true)
    }
    const showAcceptModal = (record: IDangerDetail) => {
        setMaintenanceId(record.id)
        setAcceptRecord(record)
        setAcceptModalVisible(true)
    }
    const showEditModal = (record: IDangerDetail) => {
        setEditFormData({
            id: record.id,
            amount: record.amount,
            inspectionCost: record.inspectionCost,
        })
        setEditModalVisible(true)
    }
    const columns: ColumnsType<IDangerDetail> = [
        {
            title: '序号',
            width: 55,
            align: 'center',
            fixed: 'left',
            render: (_t, _r, i) => i + 1,
        },
        {
            title: '操作',
            width: 240,
            align: 'left',
            fixed: 'left',
            render: (_text, record) => (
                <>
                    {record.itemStatus === 'unallocated' && (
                        <Button type="primary" onClick={() => showModal(record.id)} style={{ marginRight: '8px' }}>
                            <ApartmentOutlined style={{ cursor: 'pointer' }} />
                            分配技师
                        </Button>
                    )}
                    {record.itemStatus === 'to.be.confirmed' && (
                        <Button type="primary" onClick={() => showAcceptModal(record)}>
                            <SafetyOutlined style={{ cursor: 'pointer' }} />
                            验收
                        </Button>
                    )}
                    {userType === '管理员' && (
                        <Button type="primary" onClick={() => showEditModal(record)} style={{ marginRight: '8px' }}>
                            <EditOutlined style={{ cursor: 'pointer' }} />
                            编辑
                        </Button>
                    )}
                </>
            ),
        },
        {
            title: '车号',
            width: 160,
            align: 'center',
            dataIndex: 'vehicleNumber',
            fixed: 'left',
            render: (text, records) => (
                <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={() => detialLook(records)}>
                    {text}
                </span>
            ),
        },
        {
            title: '挂车',
            width: 160,
            align: 'center',
            dataIndex: 'trailerNumber',
            fixed: 'left',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '隐患单号',
            width: 160,
            align: 'center',
            dataIndex: 'hiddenCode',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '司机',
            width: 160,
            align: 'center',
            dataIndex: 'driverName',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '类型',
            width: 160,
            align: 'center',
            dataIndex: 'planType',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '部位',
            width: 160,
            align: 'center',
            dataIndex: 'inspectionPart',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '金额',
            width: 160,
            align: 'center',
            dataIndex: 'amount',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '备注',
            width: 160,
            align: 'center',
            dataIndex: 'inspectionCost',
            render: (text) => <span>{text}</span>,
        },
        {
            title: '问题项',
            width: 160,
            align: 'center',
            dataIndex: 'itemName',
            render: (text) => <YhTootip text={text} style={{ width: '160px' }} />,
        },
        {
            title: '创建日期',
            width: 160,
            align: 'center',
            dataIndex: 'createTime',
            render: (text) => <span>{changeTime(text ?? '')}</span>,
        },
        {
            title: '分配人',
            width: 160,
            align: 'center',
            dataIndex: 'lineName',
            render: () => <span>管理员</span>,
        },
        {
            title: '被分配人',
            width: 160,
            align: 'center',
            dataIndex: 'technicianName',
        },
        {
            title: '状态',
            width: 160,
            align: 'center',
            dataIndex: 'itemStatus',
            render: (text) => <span>{assignStatus[text]}</span>,
        },
    ]
    const detialLook = (record: any) => {
        let supplierEditKey = '3-3-1'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: record?.id, mode: 'look' })
        } else {
            switchNavState(supplierEditKey, {
                id: record?.id,
                trailerNumber: record?.trailerNumber,
                createTime: record?.createTime,
                mode: 'look',
            })
        }
    }

    //点击行选高亮
    const onRow = (record: IDangerDetail) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }

    return (
        <>
            <Table
                rowKey={(record) => record?.id as string}
                loading={loading}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize }).then(() => {})
                    },
                    showSizeChanger: true,
                }}
                bordered
                onRow={(record) => ({
                    onClick: () => onRow(record),
                    onContextMenu: (e) => {
                        e.preventDefault()
                        setSelectedRowKeys([record])
                    },
                })}
                scroll={{ x: 'max-content', y: 'calc(100vh - 380px)' }}
            />
            {isModalVisible && <AssignTechnicians />}
            {acceptModalVisible && <CheckAcceptance />}
            {editModalVisible && <EditDangerModal />}
        </>
    )
}
